import { render } from "./BannerAction.vue?vue&type=template&id=0aa1eff4"
import script from "./BannerAction.vue?vue&type=script&lang=js"
export * from "./BannerAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__